import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestProvider } from "./request/request";
import { UserProvider } from "./user/user";
import { SessionProvider } from "./session/session";
import { AdsProvider } from "./ads/ads";
import { EventProvider } from "./event/event";
import { ModalController, NavController } from "@ionic/angular";
// import { PremiumPaymentPage } from "../pages/premium/premium-payment/premium-payment";
import { Router } from "@angular/router";
declare let Stripe: any;

@Injectable({providedIn:'root'})
export class PaymentService {
    readonly STORAGE_KEY = "payment.attempt.data";

    constructor(
        private request: RequestProvider,
        private userService: UserProvider,
        private sessionService: SessionProvider,
        private adsService: AdsProvider,
        private eventService: EventProvider,
        private modalCtrl: ModalController,
        private router:Router,
        public navCtrl:NavController
    ) { }

    checkPaymentStatus() {
        return new Promise<any>(async (resolve, reject) => {
            let paymentAttempt: PaymentAttempt = this.retrievePaymentAttempt();
            if (!paymentAttempt) { resolve({ hasPayment: false }); return }

            let stripe = Stripe('pk_live_51IefWZEfWOjwetWPU7hpUsj3lIDQ7ziEQsRz62QIMnMhwK3WIgw0i8MWsK1kNDIzm5wSZikS7NYXeFgmfazOcaks0070GwcWzm');
            const { paymentIntent, error } = await stripe.retrievePaymentIntent(paymentAttempt.clientIntent);
            console.log('paymentIntent: ', JSON.stringify(paymentIntent));
            if (paymentIntent && (paymentIntent.status === 'succeeded' || paymentIntent.status === 'processing')) {
                this.completeSuccessPayment(paymentAttempt);
            } else {
                this.completeFailurePayment(paymentAttempt);
            }
        });
    }

    savePaymentAttempt(paymentAttempt: PaymentAttempt) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(paymentAttempt));
    }

    // completePayment(): Promise<boolean> {
    //     return new Promise<any>((resolve, reject) => {
    //         let paymentAttempt: PaymentAttempt = this.retrievePaymentAttempt();
    //         if (!paymentAttempt) { resolve(false); return }

    //         this.saveEventRegistration(paymentAttempt.token, paymentAttempt.eventId).then(() => {
    //             this.clearPaymentAttempt();
    //             resolve(true);
    //         });
    //     })
    // }

    clearPaymentAttempt() {
        localStorage.removeItem(this.STORAGE_KEY);
    }

    saveEventRegistration(token: string, eventId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.request.createPostApiPromiseWithAuth(`event/${eventId}/register`, null, {})
                .then(() => {
                    console.log('saveregist success!!');
                    resolve(true);
                })
                .catch(error => {
                    console.error(error);
                    reject(false);
                });
        });
    }

    private completeSuccessPayment(paymentAttempt: PaymentAttempt) {
        switch (paymentAttempt.product.type) {
            case ProductType.EVENT_TICKET: this.handleEventTicket(paymentAttempt); break;
            case ProductType.PREMIUM: this.handlePremium(); break;
        }
    }

    private async  completeFailurePayment(paymentAttempt: PaymentAttempt) {
        switch (paymentAttempt.product.type) {
            case ProductType.EVENT_TICKET: {
                console.log(' paymentAttempt.product.price',  paymentAttempt.product.price)
                this.eventService.getEventDetails(paymentAttempt.product.eventId).then(event => {
                    this.navCtrl.navigateForward('/event/details/tabs', {state:{event, redirect:true, amount:paymentAttempt.product.price, currency:paymentAttempt.product.currency}})
                    // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event, redirect: true, amount: paymentAttempt.product.price, currency: paymentAttempt.product.currency });
                });
            } break;
            case ProductType.PREMIUM: {
                // let modal = await this.modalCtrl.create({component:PremiumPaymentPage});
                // await modal.present();
            } break;
        }
    }

    private handleEventTicket(paymentAttempt: PaymentAttempt) {
        this.saveEventRegistration(paymentAttempt.token, paymentAttempt.product.eventId).then(() => {
            this.eventService.getQRCode(paymentAttempt.token, paymentAttempt.product.eventId).then(qrcode => {
                this.clearPaymentAttempt();
                this.navCtrl.navigateForward('/me/qrcode', {state:{qrcode:qrcode.content}});
                // (this.app.getRootNav() as NavController).push(QRCodePage, { qrcode: qrcode.content });
            });
        }).catch(err => console.error(err));
    }

    private handlePremium() {
        let profile = this.sessionService.profile;
        profile.premium = true;
        this.userService.updateProfile(profile).then((res) => {
            if (res) {
                localStorage.setItem('premium', JSON.stringify(true));
                this.adsService.hide();
                this.clearPaymentAttempt();
            }
        }).catch(err => console.error(err));
    }

    private retrievePaymentAttempt() {
        return JSON.parse(localStorage.getItem(this.STORAGE_KEY));
    }

    checkPaymentStatusSpoorts() {
        return new Promise<any>(async (resolve, reject) => {
            let paymentAttempt: PaymentAttempt = this.retrievePaymentAttempt();
            if (!paymentAttempt) { resolve({ hasPayment: false }); return }

            let stripe = Stripe('pk_live_51IefWZEfWOjwetWPU7hpUsj3lIDQ7ziEQsRz62QIMnMhwK3WIgw0i8MWsK1kNDIzm5wSZikS7NYXeFgmfazOcaks0070GwcWzm');
            const { paymentIntent, error } = await stripe.retrievePaymentIntent(paymentAttempt.clientIntent);
            console.log('paymentIntent: ', JSON.stringify(paymentIntent));
            console.log('paymentIntent.status: ', paymentIntent.status);
            if (paymentIntent && (paymentIntent.status === 'succeeded' || paymentIntent.status === 'processing')) {
                resolve({ hasPayment: true, success: true, paymentAttempt: paymentAttempt });

            } else {
                resolve({ hasPayment: true, success: false, paymentAttempt: paymentAttempt });
            }
        });
    }
}

export interface PaymentAttempt {

    navigationSystem: NavigationSystem; // ionic v3 uses the old navigation system: Stacking the Pages

    // angular, ionic 4+ path: /event-details. ionic v3 Page: EventDetailsPage;
    // TODO: fix problem in app.component.ts to push the string
    // redirectSuccessModule: string;
    // redirectFailureModule: string;

    product: Product;
    token: string;
    method: string;             // sofort, giropay, paypal
    clientIntent: string;
    appTheme?: ThemeStyle;      // designer
    lid?: any;                  // TODO: remove lid. It can be retrieved with the endpoint by token
    payload?: any;              // any JSON data to pass over the module
}

export interface ThemeStyle {
    theme: any;
    color1: string;
    color2: string;
    codeMenu: string;
    edit: string;
}
export interface Product {
    type: ProductType;
    price: any;
    currency: any;
    eventId?: any;
}
export enum ProductType {
    EVENT_TICKET,
    PREMIUM
}
export enum NavigationSystem {
    STACK,
    ROUTING
}

